import { Pipe, PipeTransform } from "@angular/core";
import { ObjectGroupViewModel } from "../../admin-panel/ObjectGroupViewModel";
import { ObjectCreateViewModel } from "../../admin-panel/Objects/Models/ObjectViewModel";
import {ObjectModel} from "../../../models/ObjectModel";
import { ObjectLiteViewModel } from "app/models/ObjectLiteViewModel";

export enum ObjectFilterType {
  Name,
  IMEI,
  Phone,
  Equipment
}

export class ObjectsFilterModel {
  public filterType: ObjectFilterType = ObjectFilterType.Name;
  public term: string = "";
  public group: ObjectGroupViewModel;
}

@Pipe({
    name: 'objectsFilter',
    pure: false,
    standalone: false
})
export class FilterObjectsPipe implements PipeTransform
{
  transform(items: ObjectLiteViewModel[], filter: ObjectsFilterModel): any
  {
    if (!items) return [];

    if (filter.term)
    {
      let filteredItems = [];

      switch (filter.filterType)
      {
        case ObjectFilterType.Name:
        {
          let lowerCaseTerm = filter.term.toLowerCase();
          for (let i = 0; i < items.length; i++)
            if (items[i].Name.toLowerCase().indexOf(lowerCaseTerm) >= 0)
              filteredItems.push(items[i]);
            //else
              //items[i].IsChecked = false;
          break;
        }
        case ObjectFilterType.IMEI:
        {
          for (let i = 0; i < items.length; i++)
            if (items[i].IMEI.toString().indexOf(filter.term) >= 0)
              filteredItems.push(items[i]);
            //else
              //items[i].IsChecked = false;
          break;
        }
        case ObjectFilterType.Phone:
        {
          for (let i = 0; i < items.length; i++)
            if (items[i].Phone.indexOf(filter.term) >= 0)
              filteredItems.push(items[i]);
            //else
              //items[i].IsChecked = false;
          break;
        }
        case ObjectFilterType.Equipment:
        {
          let lowerCaseTerm = filter.term.toLowerCase();
          for (let i = 0; i < items.length; i++)
            if (items[i].Model.toLowerCase().indexOf(lowerCaseTerm) >= 0)
              filteredItems.push(items[i]);
            //else
              //tems[i].IsChecked = false;
          break;
        }
      }
      items = filteredItems;
    }

    if (filter.group && filter.group.Id > 0)
    {
      let groupIDs = {};
      for (let i = 0; i < filter.group.objects.length; i++)
        groupIDs[filter.group.objects[i]] = 1;

      var filteredItems = [];
      for (let i = 0; i < items.length; i++)
        if (groupIDs[items[i].Id])
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;
      return filteredItems;
    }
    return items;
  }
}
